import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../Icon"

import "./styles.less"

const { Text } = Typography

const ShopifyComingSoonBanner = ({
  title = "Track your highest-risk customers by chargebacks and alerts",
  contentMarginBottom,
}) => {
  const { t } = useTranslation()
  const dataSource = useSelector((state) => state.health.dataSource)

  if (dataSource !== "shopify") return null

  return (
    <div className="shopify-coming-soon-banner">
      <div
        className="shopify-coming-soon-banner-content"
        style={contentMarginBottom ? { marginBottom: contentMarginBottom } : undefined}
      >
        <Icon type="lock" />
        <Flex gap={8} vertical style={{ marginTop: 12, marginBottom: 16 }}>
          <Text className="shopify-coming-soon-banner-title">
            {t(title)}
          </Text>
        </Flex>
        <div className="shopify-coming-soon-banner-badge">{t("Coming soon")}</div>
      </div>
    </div>
  )
}

export default ShopifyComingSoonBanner
